<script lang="ts" setup>

const { useRef } = useLayoutStore()
const [root] = useRef('root-container')

</script>

<template>
  <div id="root" ref="root">
    <slot></slot>
  </div>
</template>

<style lang="scss">
#pc #root {
  min-width: 1440px;
  height: 100vh;
  overflow: auto;
  scroll-behavior: smooth;
}
</style>
